import {ActivatedRoute} from '@angular/router';
import {Component, OnInit} from '@angular/core';

import OrderDetailsConfig from '../../table/configs/receiving-order-details-serials.json';
import {CommonService} from '../../services/common.service';

@Component({
  templateUrl: './receiving-order-details-info.component.html'
})
export class ReceivingOrderDetailsInfoComponent implements OnInit {
  public orderDetailsConfig: any;
  public orderDetailsSerials: any;
  public data: any;

  constructor(private activatedRoute: ActivatedRoute, private commonService: CommonService) {
    this.data = [];
    this.orderDetailsSerials = JSON.parse(localStorage.getItem('orderDetailsSerials'));
  }

  public async ngOnInit(): Promise<any> {
    this.activatedRoute.params.subscribe(async (params) => {

      this.orderDetailsConfig = OrderDetailsConfig;
      this.orderDetailsConfig.filter = `command_details_id=${params.id}`;
      this.data = await this.commonService.getSimpleList(`loading_command/web/basic_info/${params.id}`);
    });
  }
}
